<template>
  <div class="card card-custom grupo-auditoria">
    <div class="card-header border-0 pt-6">
      <div class="card-title">
        <div>
          <h3 class="card-label mb-1">Auditoria do grupo</h3>
          <span class="text-muted font-size-sm">
            Histórico de trocas, acessos e cópias de cadastros entre empresas.
          </span>
        </div>
      </div>
      <div class="card-toolbar">
        <router-link
          :to="{ name: 'grupoEmpresa' }"
          class="btn btn-sm btn-light-primary"
        >
          <i class="fas fa-arrow-left mr-1"></i>
          Voltar ao grupo
        </router-link>
      </div>
    </div>

    <div class="card-body pt-4">
      <div v-if="carregandoInicial" class="text-center py-10">
        <span class="spinner spinner-primary"></span>
      </div>

      <template v-else-if="grupo">
        <b-form @submit.prevent="aplicarFiltros">
          <div class="row align-items-end">
            <b-form-group
              class="col-lg-4"
              label="Evento"
              label-for="audit-acao"
            >
              <b-form-select
                id="audit-acao"
                v-model="filtros.acao"
                :options="opcoesAcao"
              />
            </b-form-group>
            <b-form-group
              class="col-lg-3"
              label="Data inicial"
              label-for="audit-inicio"
            >
              <b-form-input
                id="audit-inicio"
                v-model="filtros.inicio"
                type="date"
              />
            </b-form-group>
            <b-form-group
              class="col-lg-3"
              label="Data final"
              label-for="audit-fim"
            >
              <b-form-input
                id="audit-fim"
                v-model="filtros.fim"
                type="date"
                :min="filtros.inicio"
              />
            </b-form-group>
            <b-form-group class="col-lg-2" label="Ação" label-class="invisible">
              <button
                type="submit"
                class="btn btn-primary btn-block d-flex align-items-center justify-content-center"
                :disabled="carregando"
                data-testid="filtrar-auditoria"
              >
                Filtrar
              </button>
            </b-form-group>
          </div>
        </b-form>

        <div v-if="carregando" class="text-center py-10">
          <span class="spinner spinner-primary"></span>
        </div>

        <template v-else>
          <div v-if="registros.length" class="table-responsive">
            <table class="table table-vertical-center">
              <thead>
                <tr>
                  <th>Data e hora</th>
                  <th>Evento</th>
                  <th>Executado por</th>
                  <th>Detalhes</th>
                  <th>IP</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="registro in registros"
                  :key="registro.id_grupo_empresa_auditoria"
                >
                  <td class="text-nowrap">
                    {{ formatarDataHora(registro.created_at) }}
                  </td>
                  <td>
                    <span class="label label-light-primary label-inline">
                      {{ labelAcao(registro.acao) }}
                    </span>
                  </td>
                  <td>
                    <strong class="d-block">
                      {{ registro.executor && registro.executor.nome }}
                    </strong>
                    <small class="text-muted">
                      {{ registro.executor && registro.executor.usuario }}
                    </small>
                  </td>
                  <td>{{ descricaoRegistro(registro) }}</td>
                  <td>{{ registro.ip || "—" }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-else class="alert alert-light-info mb-0">
            Nenhum evento encontrado para os filtros selecionados.
          </div>

          <div
            v-if="paginacao.last_page > 1"
            class="d-flex justify-content-center mt-6"
          >
            <b-pagination
              v-model="paginacao.current_page"
              :total-rows="paginacao.total"
              :per-page="paginacao.per_page"
              @input="carregarAuditoria"
            />
          </div>
        </template>
      </template>

      <div v-else class="alert alert-light-warning mb-0">
        Configure um grupo empresarial antes de consultar a auditoria.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GrupoEmpresaAuditoria",
  data() {
    const hoje = new Date();
    const inicio = new Date(hoje);
    inicio.setDate(inicio.getDate() - 30);

    return {
      carregandoInicial: true,
      carregando: false,
      grupo: null,
      registros: [],
      filtros: {
        acao: "",
        inicio: this.formatarDataInput(inicio),
        fim: this.formatarDataInput(hoje),
      },
      paginacao: {
        current_page: 1,
        last_page: 1,
        per_page: 25,
        total: 0,
      },
      opcoesAcao: [
        { value: "", text: "Todos os eventos" },
        { value: "TROCA_EMPRESA", text: "Troca de empresa" },
        {
          value: "EMPRESA_PADRAO_ALTERADA",
          text: "Empresa padrão alterada",
        },
        {
          value: "ACESSO_USUARIO_ALTERADO",
          text: "Acesso de usuário alterado",
        },
        {
          value: "CADASTROS_COPIADOS",
          text: "Cadastros copiados",
        },
      ],
    };
  },
  methods: {
    formatarDataInput(data) {
      const ano = data.getFullYear();
      const mes = String(data.getMonth() + 1).padStart(2, "0");
      const dia = String(data.getDate()).padStart(2, "0");
      return `${ano}-${mes}-${dia}`;
    },
    formatarDataHora(valor) {
      if (!valor) return "—";
      return new Intl.DateTimeFormat("pt-BR", {
        dateStyle: "short",
        timeStyle: "short",
      }).format(new Date(valor));
    },
    nomeEmpresa(empresa) {
      return empresa?.nome_fantasia || empresa?.nome || "Empresa não informada";
    },
    nomeEmpresaPorId(id) {
      const membro = (this.grupo?.membros || []).find(
        (item) => Number(item.id_empresa) === Number(id)
      );
      return membro ? this.nomeEmpresa(membro.empresa) : `Empresa ${id}`;
    },
    labelAcao(acao) {
      return (
        this.opcoesAcao.find((opcao) => opcao.value === acao)?.text || acao
      );
    },
    labelEscopo(escopo, empresas = []) {
      const labels = {
        SOMENTE_EMPRESA: "Somente matriz",
        EMPRESAS_SELECIONADAS: "Empresas selecionadas",
        TODO_GRUPO: "Todo o grupo",
      };
      const nomes = empresas.map(this.nomeEmpresaPorId).join(", ");
      return `${labels[escopo] || escopo}${nomes ? ` (${nomes})` : ""}`;
    },
    descricaoRegistro(registro) {
      if (registro.acao === "ACESSO_USUARIO_ALTERADO") {
        const antes = registro.detalhes?.antes || {};
        const depois = registro.detalhes?.depois || {};
        const usuario = registro.usuario_afetado?.nome || "Usuário";
        return `${usuario}: ${this.labelEscopo(
          antes.escopo_acesso,
          antes.empresas
        )} → ${this.labelEscopo(depois.escopo_acesso, depois.empresas)}`;
      }

      if (registro.acao === "CADASTROS_COPIADOS") {
        const detalhes = registro.detalhes || {};
        const modulos = {
          UNIDADE_MEDIDA: "Unidades de medida",
          GRUPO: "Grupos",
          TRIBUTACAO: "Tributações",
          NATUREZA: "Naturezas",
          PERFIL_TRIBUTARIO: "Perfis tributários",
          PESSOA: "Pessoas",
          PRODUTO: "Produtos",
        };
        return `${modulos[detalhes.modulo] || detalhes.modulo}: ${
          detalhes.criados || 0
        } copiado(s), ${
          detalhes.existentes || 0
        } já existente(s) — ${this.nomeEmpresa(
          registro.empresa_origem
        )} → ${this.nomeEmpresa(registro.empresa_destino)}`;
      }

      return `${this.nomeEmpresa(registro.empresa_origem)} → ${this.nomeEmpresa(
        registro.empresa_destino
      )}`;
    },
    aplicarFiltros() {
      this.paginacao.current_page = 1;
      this.carregarAuditoria();
    },
    async carregarInicial() {
      this.carregandoInicial = true;

      try {
        const { data } = await this.$http.get("/empresa/grupos/atual");
        this.grupo = data?.data || null;

        if (this.grupo) {
          await this.carregarAuditoria();
        }
      } finally {
        this.carregandoInicial = false;
      }
    },
    async carregarAuditoria() {
      if (!this.grupo?.id_grupo_empresa) return;
      this.carregando = true;

      try {
        const { data } = await this.$http.get(
          `/empresa/grupos/${this.grupo.id_grupo_empresa}/auditoria`,
          {
            params: {
              acao: this.filtros.acao || undefined,
              inicio: this.filtros.inicio || undefined,
              fim: this.filtros.fim || undefined,
              page: this.paginacao.current_page,
              per_page: this.paginacao.per_page,
            },
          }
        );
        this.registros = data?.data || [];
        this.paginacao = {
          ...this.paginacao,
          ...(data?.meta || {}),
        };
      } finally {
        this.carregando = false;
      }
    },
  },
  mounted() {
    this.carregarInicial();
  },
};
</script>

<style scoped>
.grupo-auditoria .table td,
.grupo-auditoria .table th {
  vertical-align: middle;
}
</style>
